import getToken from './getToken';
import getFileUrl from './getFileUrl';
import uploadFileToS3AndCreateMetadata from './uploadFileToS3AndCreateMetadata';

export default {
  getToken,
  getFileUrl,
  uploadFileToS3AndCreateMetadata,
}
